import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { UserHistoryItem } from '@user-history/entities/user-history-item';
import { userHistoryApi } from '@user-history/user-history.api';

@Injectable()
export class HomeService {

  constructor(
    private readonly http: HttpClient
  ) { }

  public fetchUserHistoryListByHome(): Observable<UserHistoryItem[]> {
    return this.http.get<UserHistoryItem[]>(userHistoryApi.userhistory);
  }

}
